import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, breakpoints } = useTheme();
  return {
    cardStyle: (isLink, isSelected) => css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      background-color: #ffffff;
      border-radius: 0.5rem;
      padding: 1rem;
      &:hover {
        box-shadow: 0rem 0.25rem 1.25rem 0rem #00000040;
        transition: 0.5s ease;
      }
      width: 100%;
      height: 100%;
      ${breakpoints.xl} {
        flex: 1;
        height: auto;
      }
    `,
    logoStyle: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      margin-bottom: 1.875rem;
    `,
    logoImgStyle: css`
      width: 2.5rem;
      height: 2.5rem;
    `,
    sessionTitleStyle: isClub => css`
      color: ${isClub ? '#ECEEF3' : '#011e41'};
      background: ${isClub ? '#011E41' : '#eceef3'};
      border-radius: 6.25rem;
      padding: 0.5rem 0.75rem;
      font-family: FS Dillon;
      font-weight: 700;
      font-size: ${isClub ? '0.7813rem' : '0.8888rem'};
      line-height: 1rem;
      letter-spacing: 0.0016rem;
      display: inline-flex;
      gap: 0.25rem;
      align-items: center;
      justify-content: center;
    `,
    footballIcon: css`
      svg {
        display: block;
      }
    `,
    titleLocation: css`
      display: flex;
      flex-direction: column;
    `,
    headingStyle: css`
      font-family: FS Dillon;
      font-size: 1.6187rem;
      letter-spacing: 0.0021rem;
      font-weight: 700;
      color: #011e41;
      margin-bottom: 0.625rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 4rem;
      line-height: 2rem;
    `,
    locationStyle: css`
      font-size: 0.875rem;
      color: #666;
      display: inline-flex;
      gap: 0.25rem;
    `,
    distanceIcon: css``,
    text: css`
      font-weight: 700;
      font-size: 0.7037rem;
      letter-spacing: 0.075rem;
      text-transform: uppercase;
      color: #5b6885;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.4;
    `,
    infoTags: css`
      display: flex;
      flex-wrap: wrap;
      gap: 0.25rem;
    `,
    infoCapsule: (isClub, totalTags) => css`
      flex-basis: calc(33.33% - 0.25rem);
      text-align: center;
      border-radius: 6.25rem;
      padding: 0.5rem 0.75rem;
      border: 0.125rem solid #eceef3;
      font-family: FS Dillon;
      font-weight: 700;
      font-size: 0.79rem;
      letter-spacing: 0.0313rem;

      ${!isClub &&
      css`
        white-space: nowrap;
        max-width: calc(33.33% - 0.25rem);
        overflow: hidden;
        text-overflow: ellipsis;

        ${totalTags === 5 &&
        css`
          &.tag-3,
          &.tag-4 {
            flex-basis: calc(50% - 0.25rem);
            max-width: calc(50% - 0.25rem);
          }
        `}
        ${totalTags === 4 &&
        css`
          flex-basis: calc(50% - 0.25rem);
          max-width: calc(50% - 0.25rem);
        `}
        ${totalTags === 3 &&
        css`
          &.tag-0,
          &.tag-1 {
            flex-basis: calc(50% - 0.25rem);
            max-width: calc(50% - 0.25rem);
          }
          &.tag-2 {
            flex-basis: calc(100% - 0.25rem);
            max-width: calc(100% - 0.25rem);
          }
        `}
        ${totalTags === 2 &&
        css`
          flex-basis: calc(100% - 0.25rem);
          max-width: calc(100% - 0.25rem);
        `}
      `}

      ${isClub &&
      css`
        flex: 1 0 0;
      `}
    `,
    accrediation: css`
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      align-items: center;
      justify-content: flex-end;
    `,
    accrediationLogo: css`
      width: 4.375rem;
      height: 1.25rem;
    `,
    cardLink: css`
      text-decoration: none;
      color: #011e41;
      width: 100%;
      &:hover,
      &:focus {
        outline: none;
      }
      &:focus-visible:not(:hover) {
        > div:first-of-type > div:nth-of-type(2) > div:first-of-type {
          background-color: ${colors.skip_yellow};
          display: flex;
          align-items: center;
          text-decoration: underline;
          color: ${colors.border_black};
          text-decoration-color: ${colors.border_black};
        }
      }
    `,
    categoryLogo: css`
      width: 3.25rem;
      height: 3.25rem;
    `,
    clubAccrediation: css`
      display: inline-block;
      align-items: center;
      max-width: 4.375rem;
      position: relative;
    `,
    cardMoreInfoWrapper: css`
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      border-radius: 0.25rem;
      border: 1px solid #e1261c;
      background: #e1261c;
      &:hover {
        border: 1px solid #00539f;
      }
      &:has(a:active) {
        border: 1px solid #0068b2;
      }
    `,
    primaryBtn: css`
      color: #ffffff;
      background-color: #e1261c;
      text-align: center;
      font-family: 'FS Dillon';
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.25rem;
      letter-spacing: 0.24px;
      margin-left: 0px !important;
      column-gap: 0.75rem;
      &:not(:disabled) {
        &:hover {
          background-color: #00539f;
          color: #ffffff;
        }
        &:active {
          background-color: #00539f;
        }
      }
    `,
  };
};
